import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-voice-icon",
  "use": "icon-voice-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-voice-icon\">\n  <path d=\"M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z\" />\n  <path d=\"M19 10v2a7 7 0 0 1-14 0v-2\" />\n  <line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"23\" />\n  <line x1=\"8\" y1=\"23\" x2=\"16\" y2=\"23\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol